/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesFleetDtosUpdateVehicleLogbookEntryRequest,
  FacilityFlowCoreModulesFleetDtosVehicleLogbookDto,
  FacilityFlowCoreModulesFleetDtosVehicleLogbookEntriesPageDto,
  GetApiV1VehiclesLogbookParams,
  GetApiV1VehiclesLogbookPdfParams,
  GetApiV1VehiclesLogbookVehicleIdEntriesParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getVehicleLogbook = () => {
/**
 * @summary Overview of one vehicle (or all without vehicleId) for local days:
kilometres, trips and issues per vehicle, without entries.
 */
const getApiV1VehiclesLogbook = (
    params?: GetApiV1VehiclesLogbookParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesFleetDtosVehicleLogbookDto>>,) => {
      return customInstance<FacilityFlowCoreModulesFleetDtosVehicleLogbookDto>(
      {url: `/api/v1/vehicles/logbook`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary One page of a vehicle's entries, sorted by a column (chronological by default).
 */
const getApiV1VehiclesLogbookVehicleIdEntries = (
    vehicleId: string,
    params?: GetApiV1VehiclesLogbookVehicleIdEntriesParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesFleetDtosVehicleLogbookEntriesPageDto>>,) => {
      return customInstance<FacilityFlowCoreModulesFleetDtosVehicleLogbookEntriesPageDto>(
      {url: `/api/v1/vehicles/logbook/${vehicleId}/entries`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Correct readings, destination or purpose; every change is kept with name and time.
 */
const putApiV1VehiclesLogbookEntryId = (
    entryId: string,
    facilityFlowCoreModulesFleetDtosUpdateVehicleLogbookEntryRequest: FacilityFlowCoreModulesFleetDtosUpdateVehicleLogbookEntryRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/vehicles/logbook/${entryId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesFleetDtosUpdateVehicleLogbookEntryRequest
    },
      options);
    }
  /**
 * @summary The same filter as PDF (A4 portrait), optionally listing the passengers.
 */
const getApiV1VehiclesLogbookPdf = (
    params?: GetApiV1VehiclesLogbookPdfParams,
 options?: SecondParameter<typeof customInstance<Blob>>,) => {
      return customInstance<Blob>(
      {url: `/api/v1/vehicles/logbook/pdf`, method: 'GET',
        params,
        responseType: 'blob'
    },
      options);
    }
  return {getApiV1VehiclesLogbook,getApiV1VehiclesLogbookVehicleIdEntries,putApiV1VehiclesLogbookEntryId,getApiV1VehiclesLogbookPdf}};
export type GetApiV1VehiclesLogbookResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getVehicleLogbook>['getApiV1VehiclesLogbook']>>>
export type GetApiV1VehiclesLogbookVehicleIdEntriesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getVehicleLogbook>['getApiV1VehiclesLogbookVehicleIdEntries']>>>
export type PutApiV1VehiclesLogbookEntryIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getVehicleLogbook>['putApiV1VehiclesLogbookEntryId']>>>
export type GetApiV1VehiclesLogbookPdfResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getVehicleLogbook>['getApiV1VehiclesLogbookPdf']>>>
